import { Text } from "@alpacahq/ui/old";

import type { FAQItem } from "../../../../../components/common/FAQ";

export const ACCOUNT_OPENER_FAQ: FAQItem[] = [
  {
    question: "What ID should I use to verify my identity?",
    answer: (
      <Text className="font-light text-gray-800 text-sm">
        Acceptable documents for Identity verification include valid,
        government-issued photo IDs such as national ID cards, Driver’s
        licenses, or passports.
      </Text>
    ),
  },
  {
    question: "What if my address is not updated on my ID?",
    answer: (
      <Text className="font-light text-gray-800 text-sm">
        We may request additional documentation or verification of your address
        if your ID does not match the address you input.
      </Text>
    ),
  },
  {
    question: "Can I use a PO Box as my residential address?",
    answer: (
      <Text className="font-light text-gray-800 text-sm">
        No, a physical residential address is required for Ultimate Beneficial
        Owners and Authorized Persons. This address will not be used as a
        mailing address.
      </Text>
    ),
  },
];
